export * from './types';

export const STORAGE_KEY_THEME = 'theme';

export const WINDOW_EVENT = 'message';

export const ALLOWED_ORIGIN_PATTERNS: (string | RegExp)[] = [
  /^http:\/\/localhost(:\d+)?$/,
  /^http:\/\/127\.0\.0\.1(:\d+)?$/,
  /^https?:\/\/([a-zA-Z0-9-]+\.)*localstack\.cloud(:\d+)?$/,
];
